var exports = {
  "W2": "PrivacySetupModal.module__outliers___VEpsTH",
  "AU": "PrivacySetupModal.module__outliersTitle___VEpsTH",
  "Nb": "PrivacySetupModal.module__outlierList___VEpsTH",
  "YL": "PrivacySetupModal.module__outlierItem___VEpsTH",
  "UD": "PrivacySetupModal.module__outlierName___VEpsTH",
  "dr": "PrivacySetupModal.module__applyLabel___VEpsTH",
};

module.exports = exports;
